import * as React from 'react';
import {ChevronDown} from 'lucide-react';
import {AirbnbFieldTrigger} from '../field-trigger';

type AirbnbSelectTriggerProps = {
  id: string;
  open: boolean;
  label: string;
  topLabel?: string;
  helperText: string;
  valueLabel?: string;
  disabled?: boolean;
  loading?: boolean;
  optional?: boolean | string;
  tooltip?: React.ReactNode;
  helper?: React.ReactNode;
  error?: boolean | string;
  hideErrorMessage?: boolean;
  labelId: string;
  valueId: string;
  helperTextId?: string;
  errorId?: string;
  listboxId: string;
  describedBy?: string;
  onClick: () => void;
  onKeyDown: React.KeyboardEventHandler<HTMLButtonElement>;
  onBlur?: React.FocusEventHandler<HTMLButtonElement>;
};

const AirbnbSelectTrigger = React.forwardRef<HTMLButtonElement, AirbnbSelectTriggerProps>(
  (
    {
      id,
      open,
      label,
      topLabel,
      helperText,
      valueLabel,
      disabled,
      loading,
      optional,
      tooltip,
      helper,
      error,
      hideErrorMessage,
      labelId,
      valueId,
      helperTextId,
      errorId,
      listboxId,
      describedBy,
      onClick,
      onKeyDown,
      onBlur,
    },
    ref,
  ) => {
    return (
      <AirbnbFieldTrigger
        id={id}
        ref={ref}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-controls={listboxId}
        label={label}
        topLabel={topLabel}
        labelId={labelId}
        valueId={valueId}
        helperTextId={helperTextId}
        errorId={errorId}
        labelText={topLabel ? helperText : undefined}
        valueText={valueLabel}
        placeholder={helperText}
        describedBy={describedBy}
        error={error}
        loading={loading}
        optional={optional}
        tooltip={tooltip}
        helper={helper}
        forceLabelText={Boolean(optional) || Boolean(tooltip)}
        hideErrorMessage={hideErrorMessage}
        disabled={disabled}
        onClick={onClick}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
        trailingAdornment={
          <ChevronDown
            strokeWidth="1.5"
            className={
              open
                ? 'h-6 w-6 rotate-180 text-[var(--chekin-airbnb-ink)] transition-transform'
                : 'h-6 w-6 text-[var(--chekin-airbnb-ink)] transition-transform'
            }
          />
        }
      />
    );
  },
);

AirbnbSelectTrigger.displayName = 'AirbnbSelectTrigger';

export {AirbnbSelectTrigger};
